import React from 'react';
import AgendamentosOdontologiaPipeline from '../AgendamentosOdontologiaPipeline';

export default function AgendamentoCarteiraOdonto() {
  return <AgendamentosOdontologiaPipeline setor="odontologia" />;
}
